import React from 'react'
import schema from '../jsonschemas/infrastructure/infrastructure_3/infrastructure_three.json'
import uiSchema from '../jsonschemas/infrastructure/infrastructure_3/web_ui_schema.json'
import { FormPreview } from './FormPreview'

export function TestSchema3() {
  return <FormPreview schema={schema} uiSchema={uiSchema} />
}
